import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { AppRoute } from '../AppRoute.enum';

import { FeatureRouteProps } from './FeatureRoute.types';

/**
 * Guards a route behind a build-time feature flag. Hiding the entry in
 * the navigation is not enough on its own: without this guard the page
 * stays reachable by typing its URL on a build where the feature is
 * meant to be absent.
 */
export const FeatureRoute = ({ children, isEnabled }: FeatureRouteProps): ReactElement => {
  if (!isEnabled) {
    return <Navigate to={AppRoute.cards} replace />;
  }

  return children;
};
